export class HorizontalScrollContainer {
    constructor(container) {
        this.container = container
        this.scrollContainer = container.querySelector('[data-horizontal-scroll-container]')
        this.leftButton = container.querySelector('[data-scroll-left-button]')
        this.rightButton = container.querySelector('[data-scroll-right-button]')

        if (!this.scrollContainer || !this.leftButton || !this.rightButton) {
            console.warn('Horizontal scroll container missing required elements')
            return
        }

        this.leftButtonContainer = this.leftButton.parentElement
        this.rightButtonContainer = this.rightButton.parentElement
        this.updateScheduled = false

        // Bind methods to instance
        this.updateButtonVisibility = this.updateButtonVisibility.bind(this)
        this.scrollNext = this.scrollNext.bind(this)
        this.scrollPrev = this.scrollPrev.bind(this)

        this.init()
    }

    init() {
        // Initialize scroll position from data attribute
        const savedScrollPosition = parseInt(this.scrollContainer.dataset.scrollPosition) || 0
        this.scrollContainer.scrollLeft = savedScrollPosition

        // Set up event listeners
        this.scrollContainer.addEventListener('scroll', this.updateButtonVisibility, { passive: true })
        this.leftButton.addEventListener('click', this.scrollPrev)
        this.rightButton.addEventListener('click', this.scrollNext)

        // The resize observer also covers window resizes, since any that change
        // the container's size trigger it.
        new ResizeObserver(this.updateButtonVisibility).observe(this.scrollContainer)

        // Wait for images and other content to load before initial check
        window.requestAnimationFrame(() => {
            // Initial visibility check
            this.updateButtonVisibility()
        })
    }

    updateButtonVisibility() {
        if (this.updateScheduled) return

        this.updateScheduled = true
        requestAnimationFrame(() => {
            this.updateScheduled = false
            const scrollLeft = Math.round(this.scrollContainer.scrollLeft)
            const scrollWidth = this.scrollContainer.scrollWidth
            const clientWidth = this.scrollContainer.clientWidth
            const maxScroll = scrollWidth - clientWidth

            // Handle left button visibility
            if (scrollLeft <= 0) {
                this.leftButtonContainer.style.display = 'none'
            } else {
                this.leftButtonContainer.style.display = 'flex'
            }

            // Handle right button visibility
            if (scrollWidth > clientWidth) {  // If there's scrollable content
                if (Math.abs(maxScroll - scrollLeft) <= 1) {  // If we're at the end
                    this.rightButtonContainer.style.display = 'none'
                } else {
                    this.rightButtonContainer.style.display = 'flex'
                }
            } else {
                this.rightButtonContainer.style.display = 'none'
            }
        })
    }

    scrollNext() {
        const visibleWidth = this.scrollContainer.clientWidth
        this.scrollContainer.scrollBy({ left: visibleWidth, behavior: 'smooth' })
    }

    scrollPrev() {
        const visibleWidth = this.scrollContainer.clientWidth
        this.scrollContainer.scrollBy({ left: -visibleWidth, behavior: 'smooth' })
    }
}

function initializeContainer(container) {
    // A container that was already wired up keeps its listeners; creating a
    // second instance would stack duplicate scroll handlers on it.
    if (container.dataset.horizontalScrollInitialized) return

    container.dataset.horizontalScrollInitialized = "true"
    new HorizontalScrollContainer(container)
}

// Initialize on page load
document.addEventListener('turbo:load', () => {
    document.querySelectorAll('[data-horizontal-scroll]').forEach(initializeContainer)
})

// Re-initialize on Turbo frame updates
document.addEventListener('turbo:frame-render', (event) => {
    event.target.querySelectorAll('[data-horizontal-scroll]').forEach(initializeContainer)
})